import { useForm, useFormContext } from "react-hook-form";
import { ChangeStageComment } from "../../../types/pipeline";
import { AddVendedorForm } from "../../EmpresaComponents/CreateForm/AddVendedorForm";
import { Dispatch, SetStateAction, useState } from "react";
import { VendedorInfo } from "../../EmpresaComponents/EditarDealForm";
import { VisitaRegister } from "../../../types/empresa";
import { SaveButton } from "../../UtilitiesComponents/SaveButton";
import { CancelButton } from "../../UtilitiesComponents/CancelButton";
import { ValidFormCompnentes } from "../EditComponents/AddCommentChangeStage";
import { useGetTurnosQuery } from "../../../api/filter/dataFilterApi";

interface Props {
    setCurrentComponent: Dispatch<SetStateAction<ValidFormCompnentes>>
}

export function RegisterVisitaForm({ setCurrentComponent }: Props) {
    const { watch, getValues, setValue } = useFormContext<ChangeStageComment>();

    const { data: turnos } = useGetTurnosQuery();

    const [vendedoresAgregados, setVendedoresAgregados] = useState<VendedorInfo[]>([])

    const { 
        register,
        handleSubmit,
        formState: { errors }
    } = useForm<VisitaRegister>();

    const fechaInicio = watch("fechaInicio");
    const fechaFin = watch("fechaFin");

    const handleAddVisita = handleSubmit(async (data) => {
        data.vendedoresAsignados = vendedoresAgregados.map((vendedor) => vendedor.vendedorId);

        data.horaInicio = data.horaInicio != undefined 
            ? `${data.horaInicio}:00`
            : data.horaInicio;

        data.horaFin = data.horaFin != undefined 
            ? `${data.horaFin}:00`
            : data.horaFin;

        const visitas = getValues("visitas");
        setValue("visitas", [...visitas, data])
        
        setCurrentComponent("Campañas confirmadas");
    })

    return (
        <div>
            <div className="mt-2">
                <p className="text-lg font-semibold">Nueva visita</p>

                <div className="flex gap-x-3 justify-between">
                    <div>
                        <label className="text-sm font-semibold">Fecha</label>
                        <input 
                            {...register("fecha", {
                                required: "La fecha de la visita es requerida",
                                validate: {
                                    fechaIsAfterToday: (fecha) => {
                                        const today = new Date()
                                        const fechaVisita = new Date(fecha)

                                        if(fechaVisita < today)
                                            return false;

                                        return true;
                                    }
                                }
                            })}
                            min={fechaInicio}
                            max={fechaFin}
                            aria-invalid={errors.fecha ? "true" : "false"}
                            className="
                                w-full h-[26px] rounded-[3px] border-gray-400 border my-1 px-2 
                                font-semibold text-gray-600 text-sm"
                            type="date" />

                        {errors.fecha?.type === "required" && (
                            <p className="valErrorText text-sm">{errors.fecha?.message}</p>
                        )}
                        {errors.fecha?.type === "fechaIsAfterToday" && (
                            <p className="valErrorText text-sm">La fecha de la proxima visita no puede ser en un día pasado</p>
                        )}

                    </div>


                    <div>
                        <label className="text-sm font-semibold">Hora de inicio</label>
                        <input
                            {...register("horaInicio", {
                                required: "La hora de inicio es requerida",
                                validate: {
                                    horaInicioIsBeforeFin: (horaInicio, formValues) => {
                                        if(formValues.horaFin === undefined ||
                                            formValues.horaFin < horaInicio)
                                            return false;

                                        return true;
                                    }
                                },
                            })}
                            type="time"
                            aria-invalid={errors.horaInicio ? "true" : "false"}
                            className="
                                w-full h-[26px] rounded-[3px] border-gray-400 border my-1 px-2 
                                font-semibold text-gray-600 text-sm"/>

                        {errors.horaInicio?.type === "required" && (
                            <p className="valErrorText text-sm">{errors.horaInicio?.message}</p>
                        )}
                        {errors.horaInicio?.type === "horaInicioIsBeforeFin" && (
                            <p className="valErrorText text-sm">La hora de inicio no puede ser mayor a la de fin</p>
                        )}

                    </div>

                    <div>
                        <label className="text-sm font-semibold">Hora de fin</label>
                        <input
                            {...register("horaFin", {
                                required: "La hora de fin es requerida", 
                                validate: {
                                    horaFinIsAfterInicio: (horaFin, formValues) => {
                                        if(formValues.horaInicio === undefined ||
                                            horaFin < formValues.horaInicio)
                                            return false;

                                        return true;
                                    }
                                }
                            })}
                            type="time"
                            aria-invalid={errors.horaFin ? "true" : "false"}
                            className="
                                w-full h-[26px] rounded-[3px] border-gray-400 border my-1 px-2 
                                font-semibold text-gray-600 text-sm"/>

                        {errors.horaFin?.type === "required" && (
                            <p className="valErrorText text-sm">{errors.horaFin?.message}</p>
                        )}
                        {errors.horaFin?.type === "horaFinIsAfterInicio" && (
                            <p className="valErrorText text-sm">La hora de fin no puede ser antes que la de inicio</p>
                        )}

                    </div>
                </div>

                <div className="grid grid-cols-1 gap-x-2">
                    <div>
                        <label className="text-sm font-semibold">Turno</label>
                        <select
                            {...register("turno", {
                                min: 1
                            })}
                            aria-invalid={errors.turno ? "true" : "false"}
                            className="
                                w-full h-[26px] rounded-[3px] border-gray-400 border my-1 px-2 
                                font-semibold text-gray-600 text-sm">
                            <option value={0} hidden>Seleccionar</option>
                            {turnos?.map((turno, index) => (
                            <option value={turno.id} key={index}>{turno.nombre}</option>
                            ))}
                        </select>
                        {errors.turno?.type === "min" && (
                            <p className="valErrorText text-sm">{"El turno es requerido"}</p>
                        )}
                    </div>
                </div>

                <AddVendedorForm 
                    setVendedoresAgregados={setVendedoresAgregados}
                    vendedoresAgregados={vendedoresAgregados}
                    dealId={0}
                    empresaId={0}/>

            </div>

            <div className="flex gap-x-2 justify-center pb-4">
                <SaveButton
                    onClick={() => handleAddVisita()}
                    text="Agregar visita"
                    type="button" />

                <CancelButton
                    onClick={()=> {
                        setCurrentComponent("Campañas confirmadas");
                    }}/>
            </div>
        </div>
    );
}